function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 378",
  stroke: "#3c00dc"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 307",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 51,
  height: 35,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 50,
  height: 34,
  rx: 5.5
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 56",
  fill: "none",
  strokeLinecap: "round",
  d: "M4.5 6.5h42"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 102",
  transform: "translate(46 3)",
  fill: "#3c00dc"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.5,
  cy: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 103",
  transform: "translate(44 3)",
  fill: "#3c00dc"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.5,
  cy: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 104",
  transform: "translate(42 3)",
  fill: "#3c00dc"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.5,
  cy: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 105",
  transform: "translate(4 3)",
  fill: "#3c00dc"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.5,
  cy: 0.5,
  fill: "none"
})));

function SvgWebinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 35,
    viewBox: "0 0 51 35"
  }, props), _ref);
}

export default SvgWebinline;